/**
 * @module utils/attempt
 */

/**
 * @typedef {*} Value
 */

const cast = async value => value

/**
 * Resolves a value and catches/logs the error, if any, if that's a promise
 * @param {Value} value
 * @returns {Promise<Value | void>}
 */
export default async value =>
  cast(value)
    .catch(console.error)
